import { Translatable } from "@icc/shared/helpers";
import { BaseCoverType } from "./cover";

/** Typ zestawu blach */
export class BlindSheetSetType extends BaseCoverType {
    id: string | number;
    @Translatable({ model: 'BlindSheetsSetsTypes' })
    name: string;
    description: string;
    type: 'blind_sheet_set';
    img: string;
    imgSides: string;
    /** Dostępność moskitier */
    mosquitoScreenAvailability: null;
    /** Moskitiera spowoduje niemożliwość stworzenia zestawu wielu żaluzji w jednej skrzynce */
    onlyOneShutterDueMosquitoScreen: false;
    /** Odległość na rynnę górną [mm] */
    spaceToTopRailMM: number;
    /** Kod do indeksów */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    /** Kolejność */
    order: number;

    spaceBundleMm: number;
}